import { useUserClient } from '@/clients';
import type { User } from '@/shared/services/user/models';

export function useUserService(): UserService {
  const client = useUserClient();

  return new UserService(client);
}

class UserService {
  constructor(private readonly client: ReturnType<typeof useUserClient>) {}

  async getUserMe(): Promise<User> {
    return this.client.fetch({
      method: 'GET',
      url: '/me',
    });
  }
}
